import { createGlobalStyle } from "styled-components";
import { WEB_FONT_STACK_INTER } from "@orb-labs/orby-react/bullrun";
import { BULLRUN_COLORS } from "@/theme";

export const GlobalStyles = createGlobalStyle`
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
    overflow-x: clip;
    background: ${BULLRUN_COLORS.background};
  }

  body {
    font-family: ${WEB_FONT_STACK_INTER};
    font-weight: 400;
    background: ${BULLRUN_COLORS.background};
    color: #eeeef2;
    -webkit-font-smoothing: antialiased;
    overflow-x: clip;
    max-width: 100vw;
  }

  #root {
    overflow-x: clip;
    max-width: 100%;
    min-height: 100%;
    background: ${BULLRUN_COLORS.background};
  }

  a, button {
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }

  /* Animation classes (used by IntersectionObserver) - start visible so content shows; .in triggers animation */
  .v {
    opacity: 1;
    transform: none;
    transition: opacity 0.6s ease, transform 0.6s ease;
  }
  .v.in {
    opacity: 1;
    transform: none;
  }
  .v.v-1 { transition-delay: 80ms; }
  .v.v-2 { transition-delay: 160ms; }
  .v.v-3 { transition-delay: 240ms; }

  .market-card,
  .sig-card,
  .feat-row,
  .feat-tile,
  .step {
    opacity: 1;
    transform: none;
    transition: opacity 0.5s ease, transform 0.5s ease;
  }
  .markets.v.in .market-card,
  .signal-demo.v.in .sig-card,
  .features.v.in .feat-row,
  .features-grid.v.in .feat-tile,
  .steps.v.in .step {
    opacity: 1;
    transform: none;
  }
  .markets.v.in .market-card:nth-child(1),
  .signal-demo.v.in .sig-card:nth-child(1),
  .features.v.in .feat-row:nth-child(1),
  .features-grid.v.in .feat-tile:nth-child(1),
  .steps.v.in .step:nth-child(2) { transition-delay: 0ms; }
  .markets.v.in .market-card:nth-child(2),
  .signal-demo.v.in .sig-card:nth-child(2),
  .features.v.in .feat-row:nth-child(2),
  .features-grid.v.in .feat-tile:nth-child(2) { transition-delay: 100ms; }
  .steps.v.in .step:nth-child(3) { transition-delay: 400ms; }
  .markets.v.in .market-card:nth-child(3),
  .signal-demo.v.in .sig-card:nth-child(3),
  .features.v.in .feat-row:nth-child(3),
  .features-grid.v.in .feat-tile:nth-child(3) { transition-delay: 200ms; }
  .markets.v.in .market-card:nth-child(4) { transition-delay: 300ms; }
  .steps.v.in .step:nth-child(4) { transition-delay: 800ms; }
  .signal-demo.v.in .sig-card:nth-child(4) { transition-delay: 300ms; }

  .market-scroll-card.v-scroll {
    opacity: 1;
    transform: none;
    transition: opacity 0.5s ease, transform 0.5s ease;
  }
  .market-scroll-card.v-scroll.in {
    opacity: 1;
    transform: none;
  }

  .steps-connector {
    transform: translateX(-50%) scaleX(0);
    transition: transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
  }
  .steps.v.in .steps-connector {
    transform: translateX(-50%) scaleX(1);
    transition-delay: 200ms;
  }
  .steps.v.in .step:nth-child(2) .step-n {
    animation: stepPop 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }
  .steps.v.in .step:nth-child(3) .step-n {
    animation: stepPop 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.4s forwards;
  }
  .steps.v.in .step:nth-child(4) .step-n {
    animation: stepPop 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.8s forwards;
  }
  @keyframes stepPop {
    from { transform: scale(0); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  }

  @media (prefers-reduced-motion: reduce) {
    .v, .market-card, .market-scroll-card, .sig-card, .feat-row, .feat-tile, .step, .v-scroll {
      transition: none;
      opacity: 1 !important;
      transform: none !important;
    }
    .steps-connector {
      transform: translateX(-50%) scaleX(1);
      transition: none;
    }
    .step-n { animation: none !important; }
    .ticker-track { animation: none; }
  }
`;
